module.exports = __webpack_public_path__ + "static/media/drop-down-arrow.8fb2315d.svg";